import { render, staticRenderFns } from "./IconButtonBlock.vue?vue&type=template&id=1c7e80bb&scoped=true&lang=pug"
import script from "./IconButtonBlock.vue?vue&type=script&lang=ts"
export * from "./IconButtonBlock.vue?vue&type=script&lang=ts"
import style0 from "./IconButtonBlock.vue?vue&type=style&index=0&id=1c7e80bb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7e80bb",
  null
  
)

export default component.exports